import { useGetAllTeams } from 'client/modules/common/hooks/queries/admin';
import { AntPageLayoutWithHeader } from 'client/modules/permissions/components/AntPageLayoutWithHeader';
import { useNavigate } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import { debounce } from 'lodash';
import { useFiltersFromUrlSearchParams } from 'client/routes/useFilterSearchParams';
import { DataFeedRoutes } from '../routesHelper';
import { TeamFilters } from '../components/TeamFilters';
import { TeamList } from '../components/TeamList';

type DataFeedsURLSearchParams = {
  q: string;
};

export const DataFeedsPage = () => {
  const navigate = useNavigate();
  const { initialFilters } =
    useFiltersFromUrlSearchParams<DataFeedsURLSearchParams>({
      updateOnChange: true,
    });
  const { data: teams, isLoading: isLoadingTeams } = useGetAllTeams();
  const navigateWithDebounce = useCallback(
    debounce((filterTerm) => {
      const q = filterTerm !== '' ? `?q=${filterTerm}` : '';
      navigate(`${DataFeedRoutes.DataFeeds}${q}`);
    }, 300),
    []
  );

  const filteredTeams = useMemo(() => {
    if (!teams?.length) return [];

    const query = initialFilters?.q
      ? initialFilters.q.toString().toLowerCase()
      : '';
    if (!query) return teams;

    const searchTerms = query.split(' ');
    return teams.filter((team) =>
      searchTerms.every(
        (term) =>
          team.name.toLowerCase().includes(term) ||
          team.idTeam.toString().includes(term)
      )
    );
  }, [teams?.length, initialFilters?.q]);

  return (
    <AntPageLayoutWithHeader title="Data Feeds">
      <TeamFilters
        initialFilters={initialFilters.q}
        updateQueryParams={navigateWithDebounce}
      />
      <TeamList teams={filteredTeams} isLoadingTeams={isLoadingTeams} />
    </AntPageLayoutWithHeader>
  );
};
